<template>
    <form @submit.prevent="onSubmit" :class="{ 'is-loading': isLoading }">
        <div class="alert alert-danger" v-if="error" v-text="error"></div>
        <div class="alert alert-success" v-if="success" v-text="success"></div>

        <div class="form-group form-group--small" :class="{ 'is-invalid': form.errors.has('file') }">
            <label class="form-label" for="file">Bestand</label>
            <input type="file" id="file" ref="file" class="form-control" v-on:change="handleFileSelect">
        </div>

        <input type="submit" value="Uploaden" class="btn btn-primary mt-2">
    </form>
</template>

<script>
	import Form from '@/utilities/Form'
	import { UPLOAD_FILE } from '@/store/modules/projects'

	export default {

		props: ['project'],

		data () {
			return {
				error: null,
				success: null,
				isLoading: false,
                file: '',
				form: new Form({
					file: null,
				}),
			}
		},

		methods: {
			handleFileSelect () {
				this.file = this.$refs.file.files[0];
            },

			onSubmit () {
				this.isLoading = true

				let formData = new FormData();
                formData.append('file', this.file);

				this.$store.dispatch(UPLOAD_FILE, {
					project: this.project.id,
					data: formData,
				}).then((resp) => {
					this.isLoading = false;
					this.success = 'Het bestand is succesvol geupload.';

					this.$emit('fileUploaded', resp);
				}).catch(() => {
					this.isLoading = false;
					this.success = 'Er is een fout opgetreden. Probeer het later opnieuw.';
				})
			},
		},
	}
</script>